import React, { useEffect, useState } from "react";
import { Popover } from "react-bootstrap";

const TmPopoverBody = ({ children }) => {
	const height = window.innerHeight - (30 * window.innerHeight) / 100;
	const [dimension, setDimension] = useState(height);

	useEffect(() => {
		const handleWindowResize = () => {
			setDimension(height);
		};

		window.addEventListener("resize", handleWindowResize);

		return () => {
			window.removeEventListener("resize", handleWindowResize);
		};
	}, []);

	return (
		<Popover.Body>
			<div style={{ maxHeight: dimension, overflow: "auto", paddingRight: "5px" }}>
				{children}
			</div>
		</Popover.Body>
	);
};

export default TmPopoverBody;
